import api from "./api";

const postWithRouteFallback = async (paths, payload) => {
  let lastError;

  for (const path of paths) {
    try {
      const response = await api.post(path, payload);
      return response.data;
    } catch (err) {
      const status = err?.response?.status;
      const notFound = status === 404;

      if (!notFound) {
        throw err;
      }

      lastError = err;
    }
  }

  throw lastError;
};

const getWithRouteFallback = async (paths, params) => {
  let lastError;

  for (const path of paths) {
    try {
      const response = await api.get(path, { params });
      return response.data;
    } catch (err) {
      const status = err?.response?.status;
      const notFound = status === 404;

      if (!notFound) {
        throw err;
      }

      lastError = err;
    }
  }

  throw lastError;
};

const putWithRouteFallback = async (paths, payload) => {
  let lastError;

  for (const path of paths) {
    try {
      const response = await api.put(path, payload);
      return response.data;
    } catch (err) {
      const status = err?.response?.status;
      const notFound = status === 404;

      if (!notFound) {
        throw err;
      }

      lastError = err;
    }
  }

  throw lastError;
};

const normalizeTagName = (value) => String(value || "").trim().toLowerCase();

export const ensureDesenvolvimentoTagOnTicket = async ({
  ticketId,
  existingTags = [],
}) => {
  const parsedTicketId = Number(ticketId);
  if (!Number.isInteger(parsedTicketId) || parsedTicketId <= 0) {
    return;
  }

  const existingTag = Array.isArray(existingTags)
    ? existingTags.find((tag) => normalizeTagName(tag?.name) === "desenvolvimento")
    : null;

  if (existingTag?.id) {
    try {
      await api.put(`/ticket-tags/${parsedTicketId}/${existingTag.id}`);
      return;
    } catch (err) {
      const status = err?.response?.status;
      const message = String(err?.response?.data?.error || err?.message || "").toLowerCase();
      const isDuplicate =
        status === 409 ||
        message.includes("duplicate") ||
        message.includes("unique") ||
        message.includes("already");

      if (!isDuplicate) {
        throw err;
      }
      return;
    }
  }

  const { data: listedTags } = await api.get("/tags/list");
  const tagsArray = Array.isArray(listedTags) ? listedTags : [];

  let desenvolvimentoTag = tagsArray.find(
    (tag) => normalizeTagName(tag?.name) === "desenvolvimento"
  );

  if (!desenvolvimentoTag?.id) {
    const { data: createdTag } = await api.post("/tags", {
      name: "Desenvolvimento",
      color: "#35cd96",
      kanban: 0,
    });
    desenvolvimentoTag = createdTag;
  }

  if (!desenvolvimentoTag?.id) {
    return;
  }

  try {
    await api.put(`/ticket-tags/${parsedTicketId}/${desenvolvimentoTag.id}`);
  } catch (err) {
    const status = err?.response?.status;
    const message = String(err?.response?.data?.error || err?.message || "").toLowerCase();
    const isDuplicate =
      status === 409 ||
      message.includes("duplicate") ||
      message.includes("unique") ||
      message.includes("already");

    if (!isDuplicate) {
      throw err;
    }
  }
};

export const getSolicitacaoDesenvolvimentoPreview = async (ticketId) => {
  return postWithRouteFallback(
    [
      "/solicitacoes-desenvolvimento/preview",
      "/solicitacao-desenvolvimento/preview",
      "/solicitacao-desenvolvimento-preview",
    ],
    { ticketId }
  );
};

export const createSolicitacaoDesenvolvimento = async (ticketId, observacao) => {
  return postWithRouteFallback(
    [
      "/solicitacoes-desenvolvimento",
      "/solicitacao-desenvolvimento",
    ],
    { ticketId, observacao }
  );
};

export const listSolicitacoesDesenvolvimento = async ({
  pageNumber,
  searchParam,
  status,
  ticketId,
  contactId,
} = {}) => {
  return getWithRouteFallback(
    [
      "/solicitacoes-desenvolvimento",
      "/solicitacao-desenvolvimento",
    ],
    { pageNumber, searchParam, status, ticketId, contactId }
  );
};

export const updateSolicitacaoDesenvolvimentoStatus = async (id, status) => {
  return putWithRouteFallback(
    [
      `/solicitacoes-desenvolvimento/${id}/status`,
      `/solicitacao-desenvolvimento/${id}/status`,
    ],
    { status }
  );
};

export const showSolicitacaoDesenvolvimento = async (id) => {
  return getWithRouteFallback(
    [
      `/solicitacoes-desenvolvimento/${id}`,
      `/solicitacao-desenvolvimento/${id}`,
    ]
  );
};
